<template>
    <Transition v-if="isLoading"
                name="spinner">
        <div id="cover-spin">
            <span class="loader">
                <span>PROTO</span>
            </span>
        </div>
    </Transition>

    <div>
        <v-view :tableData="tableData"
                :tableProps="tableProps"
                :modalProps="modalProps"
                :columns="columns"
                :routes="routes"
                :initialSort="initialSort"
                :buttonsVisibility="buttonsVisibility"
                :rowButtonAction="rowButtonAction"
                v-model:selectedRows="selectedRows">

            <template #crud="formProps">
                <AprotForm :formProps="formProps"
                           :customData="props.customData">
                </AprotForm>
            </template>
            <template #search="searchProps">
                <AprotSearch :searchProps="searchProps">
                </AprotSearch>
            </template>

        </v-view>
    </div>
</template>

<script setup>
import AprotForm from './AprotForm.vue'
import AprotSearch from './AprotSearch.vue'
import { ref } from "vue";
import { __, getFromRoute, printReport } from '@pages/Helper/utils.js'

const selectedRows = ref([])
const isLoading = ref(false);

const props = defineProps({
    tableData: Object,
    tableProps: Object,
    modalProps: Object,
    columns: Object,
    routes: Object,
    initialSort: Object,
    buttonsVisibility: Object,
    customData: Object,
})

//------------------------------------------------------------------------------

const rowButtonAction = async function (item, rowData) {
    isLoading.value = true;
    const response = await getFromRoute('aprot-print', { 'aprot_id': rowData.id }, 'post')
    printReport(response)
    isLoading.value = false;
}

//------------------------------------------------------------------------------

</script>

<style lang="scss" scoped></style>
